import { useLandingTitle } from "../../../../common/context/landingTitle";
import { replaceText } from "../../../../common/helpers/textReplacer";
import { useProduct } from "../../../context/product";
import { getLandingName } from "./getLandingName";

import { buildProductSchema } from "../../../../../models/product";

export const useMeta = () => {
  const { product } = useProduct();
  const { metaTitle, metaDescription } = useLandingTitle();
  const landingName = getLandingName(product);
  return {
    metaDescription: replaceText(metaDescription, { landingName }),
    metaTitle: replaceText(metaTitle, { landingName }),
    productSchema: product ? buildProductSchema(product) : null,
    noIndex: Boolean(product) && !Boolean(product!.active)
  };
};
